<template>
  <RF-Dialog v-if="[ '', null, undefined ].indexOf(altura) === -1"
  :data-time="time"
  :cpntStatus='statusGeral'
  :cpntStatusImprimir='imprimindo'

  :cpntLargura='largura'
  :cpntAlturaTipo="altura.tipo"
  :cpntAlturaValor="altura.tamanho"

  :cpntOnFecharDialog='cpntVisualizarCadastroFechar' 
  ref='dialog'>
    <template slot='titulo'>
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      <span v-html='cpntVisualizarCadastroMontarTitulo'></span>
    </template>

    <template slot='botoes'>
      <div class="cpnt-vis-cad-botoes" v-show="imprimindo === false">
        <App-Button :data-time="time" v-for="(botao, indexB) in buttons" :key="indexB"
          :cpntId='botao.id'
          :cpntStatus='botao.status' 
          :cpntIcone='botao.icone'
          :cpntTexto='botao.texto'
          :cpntClass='botao.class'
          :cpntMostrar='botao.mostrar'
          :cpntDisabled="botao.disabled"
          @onClick='() => { botao.onClick(indexB) }'
        ></App-Button>
      </div>
    </template>

    <template slot='conteudo'>
      <div class="cpnt-vis-cad">
        <!-- ABRE OS DADOS DO SUBASE GERENCIAR -->
        <App-Subase-Gerenciar v-if="cpntTipo === 'contato' && acessos.subaseGer === true" v-show="imprimindo === false"
        :cpntContatoId="cpntRefId"
        :cpntRemoverCampos="[ 'filtros', 'mper', 'cartao_contato' ]"
        :cpntFecharFormulario="cpntVisualizarCadastroFechar"
        :data-time="time"
        ></App-Subase-Gerenciar>

        <!-- CRIA A OPÇÕES DE PAGINAS QUE PODEM SER ABERTAS -->
        <div class="opcoes" v-if="Object.keys(opcoes).length >= 1" v-show="imprimindo === false">
          Mostrar:
          <template v-for="(botao, indexB) in opcoes">
            <App-Button :data-time="time" :key="indexB"
            :cpntStatus='botao.status'
            :cpntTexto='botao.nome'
            :cpntClass='botao.class'
            :class="opcaoSel === indexB ? 'btn-primary' : ''"
            @onClick='() => { botao.onClick(indexB) }'
          ></App-Button>
          </template>
        </div>
        
        <!-- CIRA O ESPAÇO QUE VAI RECEBER O CONTEUDO DA TELA -->
        <div class="conteudo">
          <!-- SETA OS DADOS DO CONTATO -->
          <App-Visualizar-Cadastro-Dados :data-time="time" v-if="[ '', null, undefined ].indexOf(opcoes.dados) === -1 && opcoes.dados.iniciado !== false" v-show="opcaoSel === 'dados'"
          :cpntTipo="cpntTipo"
          :cpntRefId="cpntRefId"
          @SETAR_STATUS_GERAL='cpntVisualizarCadastroSetaStatusGeral'
          ref="dados"
          ></App-Visualizar-Cadastro-Dados>

          <!-- SETA A PAGINA DE RELACIONAMENTO -->
          <App-Visualizar-Cadastro-Relacionamentos :data-time="time" v-if="[ '', null, undefined ].indexOf(opcoes.relacionamento) === -1 && opcoes.relacionamento.iniciado !== false" v-show="opcaoSel === 'relacionamento'"
          :cpntTipo="cpntTipo"
          :cpntRefId="cpntRefId"
          @SETAR_STATUS_GERAL='cpntVisualizarCadastroSetaStatusGeral'></App-Visualizar-Cadastro-Relacionamentos>

          <!-- SETA A PAGINA DE RELACIONAMENTO -->
          <App-Visualizar-Cadastro-Credito-Devolucao :data-time="time" v-if="[ '', null, undefined ].indexOf(opcoes.credito_cli) === -1 && opcoes.credito_cli.iniciado !== false" v-show="opcaoSel === 'credito_cli'"
          :cpntIdCon="cpntRefId.toString()"
          :cpntTipo="'dev_cliente'"
          @SETAR_STATUS_GERAL='cpntVisualizarCadastroSetaStatusGeral'
          ></App-Visualizar-Cadastro-Credito-Devolucao>

          <App-Visualizar-Cadastro-Credito-Devolucao :data-time="time" v-if="[ '', null, undefined ].indexOf(opcoes.credito_for) === -1 && opcoes.credito_for.iniciado !== false" v-show="opcaoSel === 'credito_for'"
          :cpntIdCon="cpntRefId.toString()"
          :cpntTipo="'dev_fornecedor'"
          @SETAR_STATUS_GERAL='cpntVisualizarCadastroSetaStatusGeral'
          ></App-Visualizar-Cadastro-Credito-Devolucao>
          
          <!-- SETA OS DADOS DO REGISTRO DE ATENDIMENTO -->
          <App-Visualizar-Cadastro-Atendimentos-Favoritos :data-time="time" v-if="[ '', null, undefined ].indexOf(opcoes.regAtendimento) === -1 && opcoes.regAtendimento.iniciado !== false" v-show="opcaoSel === 'regAtendimento'"
          :cpntId="cpntRefId"
          :cpntStatusImprimir='imprimindo'
          :cpntFecharFormulario='cpntVisualizarCadastroFechar'
          ></App-Visualizar-Cadastro-Atendimentos-Favoritos>
        </div>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .cpnt-vis-cad-botoes > button {
    margin: 0px 5px;
  }
  .cpnt-vis-cad-botoes > button:last-child {
    margin-right: 0px;
  }

  .cpnt-vis-cad > .opcoes {
    text-align: left;
    background: #e9e9e9;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 5px;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
    .cpnt-vis-cad > .opcoes > button {
      width: 110px;
      margin: 3px;
      padding: 2px !important;
    }
</style>

<style>
  .cpnt-vis-cad-botoes > button > span > svg {
    font-size: 12px;
  }
  .cpnt-vis-cad-botoes > button > span > img,
  .cpnt-vis-cad-botoes > button > span > span > img {
    width: 12px;
    height: 12px;
  }
</style>

<script>
  // IMPORTA A BIBLIOTECA PARA IMPRESSÃO
  import '../../../../public/plugins/printElement_201/jquery.printelement.js'

  export default {
    props: {
      cpntTipo: {
        required: true,
        type: String
      },
      cpntRefId: {
        required: true,
        type: [ String, Number ]
      },
      cpntButtons: {
        required: false,
        default: function () {
          return [ 'editar' ]
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Subase-Gerenciar': () => import('@/components/subase/gerenciar/Subase-Gerenciar.vue'),
      'App-Visualizar-Cadastro-Dados': () => import('@/components/rf-geral/visualizar/Visualizar-Cadastro-Dados.vue'),
      'App-Visualizar-Cadastro-Relacionamentos': () => import('@/components/rf-geral/visualizar/Visualizar-Cadastro-Relacionamentos.vue'),
      'App-Visualizar-Cadastro-Credito-Devolucao': () => import('@/components/rf-geral/visualizar/Visualizar-Cadastro-Credito-Devolucao.vue'),
      'App-Visualizar-Cadastro-Atendimentos-Favoritos': () => import('@/components/rf-geral/visualizar/Visualizar-Cadastro-Atendimentos-Favoritos.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        altura: null,
        largura: null,
        imprimindo: false,
        acessos: {
          subaseGer: false,
          regAtendimento: false
        },
        opcaoSel: '',
        opcoes: {},
        buttons: {
          editar: {
            status: '',
            icone: 'editar',
            title: 'Editar',
            class: [ 'btn', 'btn-warning', 'btn-sm' ],
            mostrar: false,
            onClick: this.cpntVisualizarCadastroAcoes
          },
          nova_venda: {
            status: '',
            icone: 'venda-02',
            title: 'Nova venda',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: false,
            onClick: this.cpntVisualizarCadastroAcoes
          },
          atendimento: {
            status: '',
            icone: 'chat',
            title: 'Novo atendimento',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: false,
            onClick: this.cpntVisualizarCadastroAcoes
          },
          historico: {
            status: '',
            icone: 'historico',
            title: 'Histórico atendimento',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: false,
            onClick: this.cpntVisualizarCadastroAcoes
          },
          imprimir: {
            status: '',
            icone: 'impressora',
            title: 'Imprimir',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: false,
            onClick: this.cpntVisualizarCadastroAcoes
          }
        }
      }
    },
    mounted: function () {
      this.cpntVisualizarCadastroIniciar()
    },
    methods: {
      cpntVisualizarCadastroIniciar: function () {
        // VERIFICA SE A DIALOG JÁ FOI INICIADA
        var iniciado = [ '', null, undefined ].indexOf(JSON.parse(JSON.stringify(this.altura))) === -1

        // REINICIA OS CAMPOS
        this.altura = null
        this.largura = null

        // SETA O STATUS DA TELA
        this.cpntVisualizarCadastroSetaStatusGeral('carregando')

        // AGUARDA PARA DAR TEMPO DE FECHAR A DIALOG ANTIGA SE ELA ESTIVER ABERTA
        setTimeout(() => {
          // SETA A ALTURA DA PAGINA
          this.cpntVisualizarCadastroSetarDimensoes()

          // VERIFICA AS PERMISSÕES DE ACESSO
          this.acessos.subaseGer = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, [ 18 ], null, null, null, false) === true
          this.acessos.regAtendimento = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 29 ], null, [ 53 ], null, [ 569 ], null, false) === true

          // CHAMA A FUNÇÃO PARA CRIAR OS BOTOES
          this.cpntVisualizarCadastroCriarOpcoes()

          // CHAMA A FUNÇÃO PARA VER OS BOTÕES QUE DEVE MOSTRAR
          this.cpntVisualizarCadastroBotoesAcoes()

          // SETA O STATUS DA TELA
          this.cpntVisualizarCadastroSetaStatusGeral('')
        }, (iniciado === true ? 1000 : 0))
      },
      cpntVisualizarCadastroCriarOpcoes: function () {
        // INICIA A VARIAVEL DE OPÇÕES
        var opcoes = {
          dados: { iniciado: false, status: '',           nome: 'Dados' ,         class: [ 'btn', 'btn-default', 'btn-sm' ], onClick: this.cpntVisualizarCadastroOnChangeOpcoes }
        }

        // VERIFICA SE TERÁ O CREDITO DE DEVOLUÇÃO
        if (this.cpntTipo === 'contato' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === true) {
          opcoes.credito_cli = { iniciado: false, status: '', nome: 'Crédito Cliente', class: [ 'btn', 'btn-default', 'btn-sm' ], onClick: this.cpntVisualizarCadastroOnChangeOpcoes }
        }

        // VERIFICA SE TERÁ O CREDITO DE DEVOLUÇÃO
        if (this.cpntTipo === 'contato' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === true) {
          opcoes.credito_for = { iniciado: false, status: '', nome: 'Crédito Fornecedor', class: [ 'btn', 'btn-default', 'btn-sm' ], onClick: this.cpntVisualizarCadastroOnChangeOpcoes }
        }

        // SETA A OPÇÃO DE RELACIONAMENTO
        opcoes.relacionamento = { iniciado: false, status: '',  nome: 'Relacionamento', class: [ 'btn', 'btn-default', 'btn-sm' ], onClick: this.cpntVisualizarCadastroOnChangeOpcoes }

        // SETA A OPÇÃO DE RELACIONAMENTO
        if (this.cpntTipo === 'contato' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17, 5 ], 'or', null, null, null, null, false) === true) {
          opcoes.historico = { iniciado: false, status: '',  nome: 'Histórico', class: [ 'btn', 'btn-default', 'btn-sm' ], onClick: this.cpntVisualizarCadastroOnAbrirHistorico }
        }

        // VERIFICA SE PODE TER A ABA DE FAVORITOS DO REGISTRO DE ATENDIMENTO
        if (this.cpntTipo === 'contato' && this.acessos.regAtendimento === true) {
          opcoes.regAtendimento = { iniciado: false, status: '', nome: 'Favoritos', class: [ 'btn', 'btn-default', 'btn-sm' ], onClick: this.cpntVisualizarCadastroOnChangeOpcoes }
        }
        
        // SETA AS OPÇÕES QUE DEVE SELECIONAR
        this.opcoes = opcoes

        // VERIFICA SE DEVE SELECINAR A PRIMEIRA ABA ENCONTRADA
        if ([ '', null, undefined ].indexOf(this.opcaoSel) !== -1 && Object.keys(opcoes).length >= 1) {
          this.cpntVisualizarCadastroOnChangeOpcoes(Object.keys(opcoes)[0])
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntVisualizarCadastroBotoesAcoes: function () {
        // OCULTA TODOS OS BOTÕES DA TELA
        for (var indexB in this.buttons) {
          this.buttons[indexB].mostrar = false
        }

        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, null, null, null, null, null, null, false) === true) {
          // MOSTRA O BOTÃO EDITAR
          if (this.cpntTipo !== 'contato' || (this.cpntTipo === 'contato' && [ '1', '2' ].indexOf(this.cpntRefId) === -1)) {
            this.buttons.editar.mostrar = true
          }

          // VERIFICA SE TEM COMO CRIAR UMA NOVA VENDA
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 13 ], null, false) === true) {
            this.buttons.nova_venda.mostrar = true
          }

          // VERIFICA A AÇÃO PERSONALZADA
          switch (this.cpntTipo) {
            case 'contato':
              // VERIFICA SE DEVE APRESENTAR O BOTÃO PARA NOVO ATENDIMENTO
              if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 29 ], null, [ 53 ], null, [ 569 ], null, false) === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, [ 18 ], null, null, null, false) === false) {
                this.buttons.atendimento.mostrar = true
              }

              // VERIFICA SE TEM QUE MOSTRAR O HISTORICO DE ATENDIMENTO
              if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 29 ], null, [ 53 ], null, [ 569 ], null, false) === true) {
                this.buttons.historico.mostrar = true
              }

              // VERIFICA SE PODE APRESENTAR O BOTÃO EXCLUIR
              if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, [ 2 ], null, [ 329 ], null, false) === true) {
                this.buttons.imprimir.mostrar = true
              }
              break

            case 'veiculo':
              if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, [ 332 ], null, false) === true) {
                this.buttons.imprimir.mostrar = true
              }
              break

            case 'pet':
              if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, [ 565 ], null, false) === true) {
                this.buttons.imprimir.mostrar = true
              }
              break
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntVisualizarCadastroSetarDimensoes: function () {
        // SETA A LARGURA DA TELA
        var largura = '560px'

        // INICIA A VARIAVEL
        var altura = { tipo: '', tamanho: '' }

        // VERIFICA O PROCESSO QUE DEVE REALIZAR
        if ([ 'contato', 'pet', 'veiculo' ].indexOf(this.cpntTipo) !== -1) {
          // SETA O TIPO DE ALTURA
          altura.tipo = 'fixo'

          // VERIFICA O TAMANHO QUE DEVE SETAR
          switch (this.cpntTipo) {
            case 'pet':
            case 'veiculo':
              altura.tamanho = '355px'
              break

            case 'contato':
              // SETA A ALTURA DA DIALOG
              altura.tamanho = '690px'

              // SETA O TAMANHO DA DIALOG
              largura = '800px'
              break
          }
        }

        // SETA OS DADOS DA ALTURA DA DIALOG
        this.altura = altura

        // SETA A LARGURA CALCULADA
        this.largura = largura

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntVisualizarCadastroSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntVisualizarCadastroFechar: function (atualizar = false, id = null, dados = null) {
        this.cpntFecharFormulario(atualizar, id, dados)
      },
      cpntVisualizarCadastroAcoes: function (index) {
        // INICIA OS PARAMETROS QUE SERÃO UTILIZADOS
        var params = {}

        // VERIFICA A AÇÃO QUE DEVE SER FEITA
        switch (this.cpntTipo + '--' + index) {
          case 'contato--editar':
          case 'veiculo--editar':
          case 'pet--editar':
            // SETA OS PARAMETROS QUE SERÁ ENVIADO
            params = { editar: true, tipo: this.cpntTipo, id: this.cpntRefId }
            
            // VERIFICA SE DEVE ABRIR OU REDIRENCIONAR A TELA
            if (this.$route.name === 'contato_gere' && this.cpntTipo === 'contato') {
              // REDIRENCIONA PARA TELA SOLICITADA
              this.$router.push({ name: 'contato_form', params: params })

              // FECHA A TELA QUE ESTAVA ABERTA
              this.cpntVisualizarCadastroFechar(false)
            } else if (this.$route.name === 'veiculo_gere' && this.cpntTipo === 'veiculo') {
              // REDIRENCIONA PARA TELA SOLICITADA
              this.$router.push({ name: 'veiculo_form', params: params })

              // FECHA A TELA QUE ESTAVA ABERTA
              this.cpntVisualizarCadastroFechar(false)
            } else if (this.$route.name === 'pet_gere' && this.cpntTipo === 'pet') {
              // REDIRENCIONA PARA TELA SOLICITADA
              this.$router.push({ name: 'pet_form', params: params })

              // FECHA A TELA QUE ESTAVA ABERTA
              this.cpntVisualizarCadastroFechar(false)
            } else {
              // SETA O CALLBACK QUE DEVE EXECUTAR
              params.callback = (atualizar, id, dados) => {
                this.cpntVisualizarCadastroFechar(atualizar, id, dados)
              }
  
              // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
              this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
            }
            break

          case 'contato--nova_venda':
          case 'veiculo--nova_venda':
          case 'pet--nova_venda':
            if (confirm('Deseja realmente iniciar uma venda?')) {
              // REDIRECIONA PARA CRIAR A VENDA
              this.$router.push({ name: 'venda_nova_id', params: { id: this.cpntRefId, tipo: this.cpntTipo } })

              // FECHA A TELA QUE ESTAVA ABERTA
              this.cpntVisualizarCadastroFechar(false)
            }
            break

          case 'contato--atendimento':
            // SETA OS PARAMETROS PARA INICIAR
            params = { tipo: 'REGISTRO_ATENDIMENTO_INICIAR', contatoId: this.cpntRefId }
    
            // SETA A FUNÇÃO CALLBACK
            params.callback = function (atualizar) {
              if (atualizar === true) {
                this.cpntVisualizarCadastroFechar(false)
              }
            }
    
            // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
            this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
            break

          case 'contato--historico':
            // ABRE O REGISTRO DE ATENDIMENTO
            this.$store.commit('SET_REG_ATENDIMENTO', { tipo: 'busca', busca: 'con:' + this.cpntRefId })

            // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
            this.cpntVisualizarCadastroFechar(false)
            break

          case 'contato--imprimir':
          case 'veiculo--imprimir':
          case 'pet--imprimir':
            this.cpntVisualizarCadastroImprimirCartao()
            break

          default:
            this.$store.state.msgWarn('WEB [500]:  Não foi possivel identificar a ação a ser executada para o tipo (' + this.cpntTipo + ') ação (' + index + ').', 'danger')
            break
        }
      },
      cpntVisualizarCadastroOnAbrirHistorico: function () {
        // MUDA PARA TELA DE DADOS
        this.cpntVisualizarCadastroOnChangeOpcoes('dados')

        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'CONSULTAR_HISTORICO', filtros: {} }

        // SETA O TIPO DE REGISTRO QUE DEVE ABRIR
        switch (this.cpntTipo) {
          case 'contato':
            // VERIFICA A DEMANDA QUE DEVE SELECIONAR
            params.filtros.dem = [ 'dem_compra', 'dem_venda' ]
            if ([ '1' ].indexOf(this.$refs.dados.dados.id_tp_con) !== -1) {
              params.filtros.dem = [ 'dem_venda' ]
            } else if ([ '2' ].indexOf(this.$refs.dados.dados.id_tp_con) !== -1) {
              params.filtros.dem = [ 'dem_compra' ]
            }

            // SETA O CONTATO QUE DEVE BUSCAR
            params.filtros.con = [ this.cpntRefId.toString() ]
            break

          case 'veiculo':
            params.filtros.vei = [ this.cpntRefId.toString() ]
            break

          case 'pet':
            params.filtros.pet = [ this.cpntRefId.toString() ]
            break
        }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id) => {
          if (atualizar === true) {
            this.demEditarCabAtualizarDados(params._chave, id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      cpntVisualizarCadastroOnChangeOpcoes: function (value) {
        // SETA O STATUS DA TELA
        this.opcaoSel = value

        // SETA O STATUS DE INICIADO PARA O BOTÃO
        this.opcoes[this.opcaoSel].iniciado = true

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntVisualizarCadastroImprimirCartao: function () {
        // SETA A OPÇÃO QUE ESTÁ IMPRIMINDO
        this.imprimindo = true

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // AGUARDA OCULTAR OS BOTOES
        setTimeout(() => {
          // PEGA O ELEMENTO DA TELA
          var element = this.$refs.dialog.$el 

          // PEGA A DIV QUE DEVE IMPRIMIR
          element = element.querySelector('.app-dialog-modal')

          // CHAMADA DO PLUGIN PARA IMPRIMIR CONTEUDO DA DIV
          $(element).printElement()

          // SETA A OPÇÃO QUE ESTÁ IMPRIMINDO
          this.imprimindo = false

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, 1000)
      }
    },
    computed: {
      cpntVisualizarCadastroMontarTitulo: function () {
        // INICIA A VARIAVEL TITULO
        var titulo = ' Dados do '
        
        // SETA O NOME DO MODEL
        switch (this.cpntTipo) {
          case 'contato':
            titulo += 'Contato'
            break

          case 'veiculo':
            titulo += 'Veículo'
            break

          case 'pet':
            titulo += 'PET'
            break
        }
        
        // COLOCA O ID DO REGISTRO RECEBIDO
        titulo += ' ' + this.cpntRefId

        // RETORNA O VALOR MONTADO
        return titulo
      }
    }
  }
</script>
